// AB test: no_tip_jar_on_amount_page
// Can be removed when experiment has ended

import React, { createContext, useState } from 'react';

type DonationAmountContext = {
  defaultDonationAmount: number;
  donationAmount: number | undefined;
  setDonationAmount: React.Dispatch<React.SetStateAction<number | undefined>>;
  hideDonationAmount: boolean;
  setHideDonationAmount: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DonationAmountContext = createContext<
  DonationAmountContext | undefined
>(undefined);

export const DonationAmountProvider: React.FunctionComponent = ({
  children,
}) => {
  const [donationAmount, setDonationAmount] = useState<number | undefined>(
    undefined,
  );
  const [hideDonationAmount, setHideDonationAmount] = useState(false);

  return (
    <DonationAmountContext.Provider
      value={{
        defaultDonationAmount: 30, // Hard-coded default amount during test
        donationAmount,
        setDonationAmount,
        hideDonationAmount,
        setHideDonationAmount,
      }}
    >
      {children}
    </DonationAmountContext.Provider>
  );
};
